/**
 * TASIMA SIHIRBAZI — "Yandex'ten / Google'dan taşı"
 *
 * Uc adim: kaynagi tanit → ne kopyalanacagini gor → baslat.
 * Ikinci adim (onizleme) atlanabilirdi ama atlanmiyor: musteri neyin
 * kopyalanacagini gormeden parolasini vermek istemez, hakli olarak.
 */
import { useEffect, useState } from "react";
import { api } from "../api";
import { Bildirim, Bos, Durum, Kart, Olcu, Rozet, Tablo, useCek } from "../ui";

interface Saglayici {
  anahtar: string;
  ad: string;
  sunucu: string;
  port: number;
  not?: string;
}

export function Tasima() {
  const saglayicilar = useCek(() => api.tasimaSaglayicilar(), []);
  const isler = useCek(() => api.tasimalar(), []);
  const kutular = useCek(() => api.kutular(), []);

  const [adim, setAdim] = useState<1 | 2 | 3>(1);
  const [saglayici, setSaglayici] = useState("yandex");
  const [sunucu, setSunucu] = useState("");
  const [port, setPort] = useState("993");
  const [kullanici, setKullanici] = useState("");
  const [parola, setParola] = useState("");
  const [hedefEposta, setHedefEposta] = useState("");
  const [hedefParola, setHedefParola] = useState("");
  const [onizleme, setOnizleme] = useState<{ klasorler: any[]; toplamIleti: number } | null>(null);
  const [bekliyor, setBekliyor] = useState(false);
  const [hata, setHata] = useState<string | null>(null);
  const [mesaj, setMesaj] = useState<string | null>(null);

  const s: Saglayici | undefined = (saglayicilar.veri?.veri ?? []).find((x: Saglayici) => x.anahtar === saglayici);

  useEffect(() => {
    if (s && s.sunucu) {
      setSunucu(s.sunucu);
      setPort(String(s.port));
    }
  }, [saglayici, saglayicilar.veri]);

  // Suren is varsa ilerlemeyi tazele
  useEffect(() => {
    const surenVar = (isler.veri?.veri ?? []).some((i: any) => i.durum === "calisiyor" || i.durum === "bekliyor");
    if (!surenVar) return;
    const t = setInterval(() => isler.yenile(), 5000);
    return () => clearInterval(t);
  }, [isler.veri]);

  async function onizle() {
    setBekliyor(true);
    setHata(null);
    try {
      const y = await api.tasimaOnizle({ saglayici, sunucu, port: Number(port), kullanici, parola });
      setOnizleme(y.veri);
      setAdim(2);
    } catch (e: any) {
      setHata(e?.message ?? "Kaynak hesaba bağlanılamadı");
    } finally {
      setBekliyor(false);
    }
  }

  async function baslat() {
    setBekliyor(true);
    setHata(null);
    try {
      const y = await api.tasimaBaslat({
        saglayici,
        sunucu,
        port: Number(port),
        kullanici,
        parola,
        hedefEposta,
        hedefParola,
      });
      setMesaj(y.mesaj);
      setAdim(3);
      // Parolalar bellekte tutulmaz
      setParola("");
      setHedefParola("");
      isler.yenile();
    } catch (e: any) {
      setHata(e?.message ?? "Taşıma başlatılamadı");
    } finally {
      setBekliyor(false);
    }
  }

  return (
    <>
      <div className="baslik">
        <div>
          <h1>Posta taşıma</h1>
          <p>
            Eski sağlayıcınızdaki (Yandex, Gmail, Outlook…) postaları buraya kopyalar.{" "}
            <strong>Kaynak hesabınızdan hiçbir şey silinmez</strong>; istediğiniz kadar açık
            tutabilirsiniz.
          </p>
        </div>
      </div>

      {hata && <Bildirim tur="kotu">{hata}</Bildirim>}
      {mesaj && <Bildirim tur="iyi">{mesaj}</Bildirim>}

      <div className="sekmeler">
        <button className={"sekme" + (adim === 1 ? " etkin" : "")} onClick={() => setAdim(1)}>
          1. Kaynak hesap
        </button>
        <button className={"sekme" + (adim === 2 ? " etkin" : "")} disabled={!onizleme} onClick={() => setAdim(2)}>
          2. Ne kopyalanacak
        </button>
        <button className={"sekme" + (adim === 3 ? " etkin" : "")} onClick={() => setAdim(3)}>
          3. İşlemler
        </button>
      </div>

      {adim === 1 && (
        <Kart baslik="Postalar nereden gelecek?">
          <div className="izgara d2">
            <label className="alan">
              <span>Sağlayıcı</span>
              <select value={saglayici} onChange={(e) => setSaglayici(e.target.value)}>
                {(saglayicilar.veri?.veri ?? []).map((x: Saglayici) => (
                  <option key={x.anahtar} value={x.anahtar}>
                    {x.ad}
                  </option>
                ))}
              </select>
            </label>
            <label className="alan">
              <span>IMAP sunucusu</span>
              <input value={sunucu} onChange={(e) => setSunucu(e.target.value)} placeholder="imap.ornek.com" />
            </label>
            <label className="alan">
              <span>Port</span>
              <input value={port} onChange={(e) => setPort(e.target.value.replace(/\D/g, ""))} inputMode="numeric" />
              <small>993 = SSL (önerilen), 143 = STARTTLS</small>
            </label>
            <label className="alan">
              <span>Eski hesabın adresi</span>
              <input
                value={kullanici}
                onChange={(e) => setKullanici(e.target.value.trim())}
                placeholder="ad@eskisaglayici.com"
                autoComplete="off"
              />
            </label>
            <label className="alan">
              <span>Eski hesabın parolası</span>
              <input
                type="password"
                value={parola}
                onChange={(e) => setParola(e.target.value)}
                autoComplete="new-password"
              />
              <small>
                Parola yalnızca kopyalama süresince şifreli olarak saklanır ve işlem bitince silinir.
              </small>
            </label>
          </div>

          {s?.not && <Bildirim tur="uyari">{s.not}</Bildirim>}

          <button className="dugme ana" disabled={!kullanici || !parola || !sunucu || bekliyor} onClick={onizle}>
            {bekliyor ? "Bağlanılıyor…" : "Bağlan ve neler olduğuna bak"}
          </button>
        </Kart>
      )}

      {adim === 2 && onizleme && (
        <>
          <Kart baslik="Kopyalanacaklar">
            <div className="izgara d4">
              <Olcu ad="Klasör" deger={onizleme.klasorler.length} />
              <Olcu ad="Kopyalanacak ileti" deger={onizleme.toplamIleti} />
            </div>
            <Tablo basliklar={["Kaynak klasör", "#İleti", "Hedef klasör"]}>
              {onizleme.klasorler.map((k: any) => (
                <tr key={k.ad}>
                  <td>{k.ad}</td>
                  <td className="sayi">{k.ileti}</td>
                  <td>
                    {k.hedef === "(kopyalanmayacak)" ? <Rozet>atlanacak</Rozet> : <code>{k.hedef}</code>}
                  </td>
                </tr>
              ))}
            </Tablo>
            <small style={{ display: "block", marginTop: 10 }}>
              Gmail'in "Tüm Postalar" ve "Yıldızlı" klasörleri kopyalanmaz: bunlar ayrı klasör
              değil, aynı iletilerin etiketidir. Kopyalansaydı her posta iki kez görünürdü.
            </small>
          </Kart>

          <Kart baslik="Nereye kopyalanacak?">
            <div className="izgara d2">
              <label className="alan">
                <span>Hedef posta kutusu</span>
                <select value={hedefEposta} onChange={(e) => setHedefEposta(e.target.value)}>
                  <option value="">seçin…</option>
                  {(kutular.veri?.veri ?? []).map((k: any) => (
                    <option key={k.id} value={k.emailAddress}>
                      {k.emailAddress}
                    </option>
                  ))}
                </select>
              </label>
              <label className="alan">
                <span>Hedef kutunun parolası</span>
                <input
                  type="password"
                  value={hedefParola}
                  onChange={(e) => setHedefParola(e.target.value)}
                  autoComplete="new-password"
                />
                <small>
                  Bilmiyorsanız Posta kutuları ekranından parolayı yenileyip yeni parolayı buraya
                  yazın.
                </small>
              </label>
            </div>
            <Bildirim>
              Aynı ileti iki kez kopyalanmaz. Taşımayı istediğiniz kadar tekrarlayabilirsiniz; yalnızca
              yeni gelenler eklenir.
            </Bildirim>
            <div style={{ display: "flex", gap: 8 }}>
              <button className="dugme" onClick={() => setAdim(1)}>
                ← Geri
              </button>
              <button
                className="dugme ana"
                disabled={!hedefEposta || !hedefParola || bekliyor}
                onClick={baslat}
              >
                {bekliyor ? "Başlatılıyor…" : `${onizleme.toplamIleti} iletiyi kopyala`}
              </button>
            </div>
          </Kart>
        </>
      )}

      {adim === 3 && (
        <Durum cekim={isler}>
          {(y) =>
            y.veri.length === 0 ? (
              <Kart>
                <Bos>Henüz taşıma yapılmadı.</Bos>
              </Kart>
            ) : (
              <Kart baslik={`Taşıma işleri (${y.veri.length})`}>
                <Tablo basliklar={["Kaynak", "Hedef", "Durum", "İlerleme", "Başlangıç", ""]}>
                  {y.veri.map((i: any) => {
                    const ilerleme = i.ilerleme ? JSON.parse(i.ilerleme) : [];
                    const kopya = ilerleme.reduce((t: number, x: any) => t + x.kopyalanan, 0);
                    const atlanan = ilerleme.reduce((t: number, x: any) => t + x.atlanan, 0);
                    const toplam = ilerleme.reduce((t: number, x: any) => t + x.toplam, 0);
                    return (
                      <tr key={i.id}>
                        <td>
                          <div>{i.kaynak_kul}</div>
                          <small>{i.kaynak_sunucu}</small>
                        </td>
                        <td>{i.hedef_eposta}</td>
                        <td>
                          {i.durum === "bitti" ? (
                            <Rozet tur="iyi">bitti</Rozet>
                          ) : i.durum === "hata" ? (
                            <Rozet tur="kotu">hata</Rozet>
                          ) : i.durum === "calisiyor" ? (
                            <Rozet tur="uyari">sürüyor</Rozet>
                          ) : (
                            <Rozet>{i.durum}</Rozet>
                          )}
                          {i.hata && <div className="not">{i.hata}</div>}
                        </td>
                        <td>
                          {toplam > 0 ? (
                            <>
                              <div className="cubuk">
                                <i style={{ width: Math.min(100, ((kopya + atlanan) / toplam) * 100) + "%" }} />
                              </div>
                              <small>
                                {kopya} kopyalandı{atlanan ? `, ${atlanan} zaten vardı` : ""} / {toplam}
                              </small>
                            </>
                          ) : (
                            <small>—</small>
                          )}
                        </td>
                        <td>
                          <small>{i.baslangic}</small>
                        </td>
                        <td>
                          {(i.durum === "calisiyor" || i.durum === "bekliyor") && (
                            <button
                              className="dugme kucuk"
                              onClick={() => api.tasimaIptal(i.id).then(() => isler.yenile())}
                            >
                              durdur
                            </button>
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </Tablo>
              </Kart>
            )
          }
        </Durum>
      )}
    </>
  );
}
